import { __decorate, __param, __metadata, __awaiter } from 'tslib';
import { Injectable, Inject, NgModule, Optional, SkipSelf } from '@angular/core';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { Storage, IonicStorageModule } from '@ionic/storage';
import { APP_PARAMETER } from '@wlp/ui-bs-parameter';
import { BaseService, UiBsUtilModule } from '@wlp/ui-bs-util';
import { SpeViewNAccountProxy, SpeNAccountsProxy, ConfigService, SpeNOpenAccountProxy, UiPxLoginModule } from '@wlp/ui-px-login';
import { KeycloakService } from 'keycloak-angular';
export * from 'keycloak-angular';
import { BehaviorSubject } from 'rxjs';
import { AuthUtilBase } from '@wlp/ui-bs-oauth';
import { IonicModule } from '@ionic/angular';

let RegistryDeviceService = class RegistryDeviceService extends BaseService {
    constructor(speViewNAccountProxy, speNAccountsProxy, formBuilder, configService, storage, param) {
        super(storage, configService);
        this.speViewNAccountProxy = speViewNAccountProxy;
        this.speNAccountsProxy = speNAccountsProxy;
        this.formBuilder = formBuilder;
        this.configService = configService;
        this.storage = storage;
        this.param = param;
        this.errorMessages = {
            reasonDescription: [
                {
                    type: 'maxlength',
                    message: 'CASH_OUT.ACCOUNT_CHARGING.FORM.VALUE_FIELD.MESSAGE.MAX_LENGTH',
                    param: {
                        maxLength: 120,
                    },
                },
            ]
        };
    }
    createFormRegisteredDevice() {
        this.registeredDeviceForm = this.formBuilder.group({
            reasonDescription: new FormControl('', Validators.compose([Validators.maxLength(120)])),
        });
        return this.registeredDeviceForm;
    }
    getErrorMessages() {
        return this.errorMessages;
    }
    validateDevice(uuidDevicePhysical, uuidWhiteLabel) {
        return this.speViewNAccountProxy.validateDevice(uuidDevicePhysical, uuidWhiteLabel);
    }
    saveDevice(device) {
        return this.speNAccountsProxy.saveDevice(device);
    }
    revokeDevice(uuidDevice) {
        return this.speNAccountsProxy.revokeDevice(uuidDevice);
    }
    deviceAction(device) {
        return this.speNAccountsProxy.deviceAction(device);
    }
    getListDevices() {
        return this.speViewNAccountProxy.getListDevices();
    }
    getPartnerDevices() {
        return this.speViewNAccountProxy.getPartnerDevices();
    }
    partnerActionsDevice(device) {
        return this.speNAccountsProxy.partnerActionsDevice(device);
    }
    generateCodeSMS() {
        return this.speNAccountsProxy.generateCodeSMS();
    }
    generateCodeEmail() {
        return this.speNAccountsProxy.generateCodeEmail();
    }
};
RegistryDeviceService = __decorate([
    Injectable(),
    __param(5, Inject(APP_PARAMETER)),
    __metadata("design:paramtypes", [SpeViewNAccountProxy,
        SpeNAccountsProxy,
        FormBuilder,
        ConfigService,
        Storage, Object])
], RegistryDeviceService);

class ExtraAttribute {
}
class UserInfoProfile {
    constructor() {
        this.listAccounts = [];
    }
    isRoleMenu(role) {
        if (this.rolesMenu && this.rolesMenu.length > 0) {
            const existsRole = this.rolesMenu.filter(r => r == role);
            return existsRole.length > 0;
        }
        return false;
    }
}

let UserInfoService = class UserInfoService extends BaseService {
    constructor(speNOpenAccountProxy, speViewNAccountProxy, speNAccountsProxy, configService, storage, keycloakService, authUtil, param) {
        super(storage, configService);
        this.speNOpenAccountProxy = speNOpenAccountProxy;
        this.speViewNAccountProxy = speViewNAccountProxy;
        this.speNAccountsProxy = speNAccountsProxy;
        this.configService = configService;
        this.storage = storage;
        this.keycloakService = keycloakService;
        this.authUtil = authUtil;
        this.param = param;
        this.accountsCache = new BehaviorSubject(null);
    }
    setUuidAccount(uuid, uuidWl) {
        localStorage.setItem('uuid_account_' + uuidWl, String(uuid));
    }
    changeAccount(userId) {
        return this.speNAccountsProxy.changeAccount(userId).subscribe(res => {
            return true;
        });
    }
    getPersonalDataContact() {
        return this.speViewNAccountProxy.personalDataContact();
    }
    getPersonalDataUser() {
        return this.speViewNAccountProxy.personalDataUser();
    }
    getInfoProfile() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                let userProfile = new UserInfoProfile();
                const userDetails = yield this.keycloakService.loadUserProfile();
                const uuidAccount = this.cleanAttribute(this.searchAttribute(userDetails, 'uuidAccount'));
                let accounts;
                if (!this.accountsCache.value) {
                    accounts = yield this.speViewNAccountProxy.getAccounts().toPromise();
                    this.accountsCache.next(accounts);
                }
                else {
                    accounts = this.accountsCache.value;
                }
                for (const ac of accounts) {
                    if (!uuidAccount) {
                        this.changeAccount(ac.userId);
                    }
                    if (!uuidAccount || uuidAccount === ac.uuidAccount) {
                        userProfile.email = userDetails.email;
                        userProfile.isEC = false;
                        userProfile.uuidWhiteLabel = ac.uuidWl;
                        userProfile.uuidAccount = uuidAccount;
                        userProfile.nameComplete = ac.accountName;
                        userProfile.nameFirst = ac.accountName.split(' ')[0];
                        userProfile.nameInitials = ac.nameInitials;
                        userProfile.codeBank = ac.codeBank;
                        userProfile.nameBank = ac.nameBank;
                        userProfile.agencyBank = ac.agencyBank;
                        userProfile.numberAccountBank = ac.numberAccountBank;
                        userProfile.userEmail = ac.userEmail;
                        userProfile.userDocument = ac.userDocument;
                        userProfile.userName = ac.userName;
                        userProfile.accountType = ac.accountType;
                        userProfile.extraAttributes = this.preparerExtraAttribute(userDetails);
                        userProfile.rolesMenu = ac.rolesMenu;
                        userProfile.listAccounts.push(ac);
                    }
                    else {
                        userProfile.listAccounts.push(ac);
                    }
                }
                return userProfile;
            }
            catch (e) {
                console.error('Failed to load user details', e);
                this.logoutForTimeOut();
            }
        });
    }
    captureValue(value) {
        if (value && typeof value === 'object' && value.constructor === Array) {
            return value[0];
        }
        else {
            return value;
        }
    }
    searchAttribute(keycloakProfile, attributeSearch) {
        if (keycloakProfile.attributes) {
            const keyNames = Object.keys(keycloakProfile.attributes);
            for (const attribute of keyNames) {
                if (attribute === attributeSearch) {
                    return this.captureValue(keycloakProfile.attributes[attribute]);
                }
            }
        }
        return null;
    }
    cleanAttribute(attribute) {
        if (attribute) {
            // @ts-ignore
            return (attribute + '').replace('"', '').replace('"', '');
        }
        return attribute;
    }
    preparerExtraAttribute(keycloakProfile) {
        let extras = new Array();
        if (keycloakProfile.attributes) {
            const keyNames = Object.keys(keycloakProfile.attributes);
            for (const attribute of keyNames) {
                if (attribute !== 'uuidAccount' &&
                    attribute !== 'uuidWhiteLabel' &&
                    attribute !== 'nameInitials' &&
                    attribute !== 'codeBank' &&
                    attribute !== 'nameBank' &&
                    attribute !== 'agencyBank' &&
                    attribute !== 'numberAccountBank' &&
                    attribute !== 'isEC' &&
                    attribute !== 'uuidWl' &&
                    attribute !== 'uuidAccount') {
                    extras.push({ key: attribute, value: this.captureValue(keycloakProfile.attributes[attribute]) });
                }
            }
            return extras;
        }
        return extras;
    }
    getRoles() {
        return this.keycloakService.getUserRoles(true);
    }
    isUserInRole(role, resource = undefined) {
        return this.keycloakService.isUserInRole(role, resource);
    }
    logoutForTimeOut() {
        let redirectUrl = document.location.protocol + '//' + document.location.hostname;
        if (document.location.hostname.includes('localhost')) {
            redirectUrl += ':' + document.location.port;
        }
        this.onLogout(redirectUrl);
    }
    onLogout(redirectUri) {
        this.keycloakService.logout(redirectUri);
    }
    getApplicationAccess() {
        const roles = this.getRoles();
        const applicationBase = this.param.config.wlThemeParameterization.wlTheme.application;
        let applicationAccess = [];
        if (applicationBase) {
            for (const role of roles) {
                const appInclude = applicationBase.filter((app) => app.roles.includes(role));
                if (appInclude) {
                    appInclude.forEach((include) => {
                        applicationAccess.push(include);
                    });
                }
            }
        }
        return applicationAccess;
    }
    hasLiveness() {
        return __awaiter(this, void 0, void 0, function* () {
            const token = yield this.keycloakService.getToken();
            return this.authUtil.isValidLiveness(token);
        });
    }
};
UserInfoService = __decorate([
    Injectable(),
    __param(7, Inject(APP_PARAMETER)),
    __metadata("design:paramtypes", [SpeNOpenAccountProxy,
        SpeViewNAccountProxy,
        SpeNAccountsProxy,
        ConfigService,
        Storage,
        KeycloakService,
        AuthUtilBase, Object])
], UserInfoService);

var UiBsLoginModule_1;
let UiBsLoginModule = UiBsLoginModule_1 = class UiBsLoginModule {
    constructor(parentModule) {
        //...
    }
    static forRoot(config) {
        return {
            ngModule: UiBsLoginModule_1,
            providers: [
                { provide: APP_PARAMETER, useValue: config }
            ]
        };
    }
};
UiBsLoginModule = UiBsLoginModule_1 = __decorate([
    NgModule({
        declarations: [],
        imports: [
            IonicModule,
            IonicStorageModule.forRoot({
                driverOrder: ['indexeddb', 'sqlite', 'websql']
            }),
            UiPxLoginModule,
            UiBsUtilModule
        ],
        providers: [UserInfoService, RegistryDeviceService]
    }),
    __param(0, Optional()), __param(0, SkipSelf()),
    __metadata("design:paramtypes", [UiBsLoginModule])
], UiBsLoginModule);

class RegisterDeviceDTO {
}

class DeviceActionDTO {
}

var DeletedEnum;
(function (DeletedEnum) {
    DeletedEnum["FALSE"] = "0";
    DeletedEnum["TRUE"] = "1";
})(DeletedEnum || (DeletedEnum = {}));

var TypeValidationEnum;
(function (TypeValidationEnum) {
    TypeValidationEnum["INTERNAL"] = "INTERNAL";
    TypeValidationEnum["IDUNICO"] = "IDUNICO";
})(TypeValidationEnum || (TypeValidationEnum = {}));

var DeviceStatusEnum;
(function (DeviceStatusEnum) {
    DeviceStatusEnum["BLOCK"] = "BLOCK";
    DeviceStatusEnum["LOSS"] = "LOSS";
    DeviceStatusEnum["THEFT"] = "THEFT";
    DeviceStatusEnum["REVOKED"] = "REVOKED";
    DeviceStatusEnum["UNLOCK"] = "UNLOCK";
    DeviceStatusEnum["ACTIVE"] = "ACTIVE";
})(DeviceStatusEnum || (DeviceStatusEnum = {}));

export { DeletedEnum, DeviceActionDTO, DeviceStatusEnum, ExtraAttribute, RegisterDeviceDTO, RegistryDeviceService, TypeValidationEnum, UiBsLoginModule, UserInfoProfile, UserInfoService };
//# sourceMappingURL=wlp-ui-bs-login.js.map
